import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  candidateLoadingSelector,
  candidateProfileSelector,
  clearOnboardingRedirectFlag,
  completeOnboarding,
  onboardingSelector,
  profileUpdateSuccessSelector,
  setProfileUpdateSuccess,
  setShouldCompleteOnboarding,
  shouldCompleteOnboardingSelector,
  shouldRedirectAfterOnboardingSelector,
  updateCandidateProfile
} from '../../redux/features/candidate/candidateSlice';
import {
  currentFileSelector,
  isProcessingSelector,
  uploadFile
} from '../../redux/features/file/filesSlice';
import { ProfileOnboardingStepper } from '../CandidateProfile/components';
import { APP_PATH_CANDIDATE_PROFILE } from '../../config';
import { useCurrentUserInfo } from '../../hooks/useCurrentUserInfo';

const Onboarding = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { user } = useCurrentUserInfo();
  const profile = useSelector(candidateProfileSelector);
  const isLoading = useSelector(candidateLoadingSelector);
  const currentFile = useSelector(currentFileSelector);
  const isProcessingFile = useSelector(isProcessingSelector);
  const onboarding = useSelector(onboardingSelector);
  const shouldRedirect = useSelector(shouldRedirectAfterOnboardingSelector);
  const profileUpdateSuccess = useSelector(profileUpdateSuccessSelector);
  const shouldCompleteOnboardingFlag = useSelector(
    shouldCompleteOnboardingSelector
  );

  // Check if onboarding is completed from Redux state
  const canClose =
    onboarding?.status === 'COMPLETED' || onboarding?.status === 'SKIPPED';

  // Watch for redirect flag from Redux and redirect
  useEffect(() => {
    if (shouldRedirect) {
      console.log(
        '✅ [Onboarding] Onboarding completed, redirecting to profile'
      );
      dispatch(clearOnboardingRedirectFlag());
      history.push(APP_PATH_CANDIDATE_PROFILE);
    }
  }, [shouldRedirect, dispatch, history]);

  // Watch for profile update success to trigger onboarding completion
  useEffect(() => {
    console.log(
      '🔍 [Onboarding] Flag check - profileUpdateSuccess:',
      profileUpdateSuccess,
      'shouldCompleteOnboardingFlag:',
      shouldCompleteOnboardingFlag
    );
    if (profileUpdateSuccess && shouldCompleteOnboardingFlag) {
      console.log(
        '✅ [Onboarding] Profile updated successfully, completing onboarding'
      );
      console.log(
        '📦 [Onboarding] Current profile in Redux:',
        JSON.stringify(profile, null, 2)
      );
      // Send only the intro fields
      dispatch(updateCandidateProfile(profile));
      dispatch(completeOnboarding());
      // Reset flags
      dispatch(setProfileUpdateSuccess(false));
      dispatch(setShouldCompleteOnboarding(false));
    }
  }, [profileUpdateSuccess, shouldCompleteOnboardingFlag, dispatch, profile]);

  const handleClose = () => {
    // Only allow closing if onboarding is completed
    if (canClose) {
      console.log('✅ [Onboarding] Allowing close - onboarding completed');
      history.push(APP_PATH_CANDIDATE_PROFILE);
    } else {
      console.log('⚠️ [Onboarding] Close prevented - onboarding not completed');
    }
  };

  const handleSave = (data, shouldClose) => {
    console.log('💾 [Onboarding] Saving profile data', data);

    // Reset flag before starting
    dispatch(setProfileUpdateSuccess(false));

    // Save the candidate profile data
    dispatch(updateCandidateProfile(data));

    // If shouldClose is true, set flag to complete onboarding after profile update
    if (shouldClose) {
      console.log(
        '🎯 [Onboarding] Will complete onboarding after profile update'
      );
      dispatch(setShouldCompleteOnboarding(true));
    }
  };

  const handlePhotoUpload = (file) => {
    console.log('📸 [Onboarding] Uploading photo:', file.name);
    dispatch(uploadFile({ file }));
  };

  const userName = user?.fullName || user?.full_name || user?.email || 'User';
  const photoUrl = currentFile?.publicUrl;

  return (
    <ProfileOnboardingStepper
      open={true}
      onClose={handleClose}
      onSave={handleSave}
      initialData={profile || {}}
      loading={isLoading || isProcessingFile}
      photoUrl={photoUrl}
      onPhotoUpload={handlePhotoUpload}
      userName={userName}
    />
  );
};

export default Onboarding;
